module.exports = __webpack_public_path__ + "98b4f351860d4b6447b9917165e54a12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/ChequeImageView/routing-number.svg
// module id = 2409
// module chunks = 0 1